import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '3402382169937662';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    // If already initialized, just track the page view
    if (window.fbq) {
      try {
        window.fbq('track', 'PageView');
      } catch (e) {
        // no-op
      }
      return;
    }
    try {
      // Stub fbq so calls made before the script loads get queued
      const n: any = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      window.fbq = n;
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Append the Meta Pixel script safely to <head>
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const target = document.head || document.getElementsByTagName('head')[0] || document.body;
      if (target) {
        target.appendChild(script);
      }
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (e) {
      // Silently ignore — pixel should never break the page
      // eslint-disable-next-line no-console
      console.warn('Meta Pixel init failed:', e);
    }
  }, []);
  return <noscript data-id="element-172">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-173" />
    </noscript>;
}